export default {
  LOGIN_FRAUD_ERROR: new Error("Unable to perform this action at this time."),
  EXPIRED_CREDENTIALS: new Error("Credentials expired."),
  FINGERPRINT_VALIDATION_FAILED: new Error("Invalid TouchID / Fingerprint."),
  INVALID_CREDENTIALS: new Error("Invalid Credentials"),
  NO_FINGERPRINTS_ENROLLED: new Error("No TouchID / Fingerprint Hardware detected."),
  NO_PASSCODE: new Error("No saved Passcode found."),
  NO_SAVED_CREDENTIALS: new Error("No Saved Credentials"),
  NO_TOUCHID_HARDWARE: new Error("No TouchID / Fingerprint Hardware detected."),
  PASSCODE_MANDATORY: new Error("Passcode is mandatory if you opt-in to remember Credentials."),
  PASSCODE_VALIDATION_FAILED: new Error("Passcode validation failed."),
  UPDATE_FIRST_NAME_FAILED: new Error("Unable to update your First Name."),
  UPDATE_LAST_NAME_FAILED: new Error("Unable to update your Last Name."),
  UPDATE_SECURITY_QUESTION_FAILED: new Error("Unable to update your Security Question."),
  UPDATE_PHONE_NUMBER_FAILED: new Error("Unable to update your Phone Number."),
  UPDATE_EMAIL_ADDRESS_FAILED: new Error("Unable to update your Email Address."),
  UPDATE_USER_LAST_NAME: new Error("Unable to update your Last Name."),
  UPDATE_PASSWORD_FAILED: new Error("Unable to update your Password."),
  UPDATE_DOB_FAILED: new Error("Unable to update your Date of Birth."),
  RESET_PASSWORD_FAILED: new Error("Unable to reset your Password."),
  UPDATE_FAVORITE_LOCATION: new Error("Unable to update your favorite Location."),
  FETCH_LOCATION_RESTAURANT_FAILED: new Error("An Error Occured."),
  SAVE_GIFT_CARD_TO_PROFILE_FAILED: new Error("Failed to save Gift Card"),
  SAVE_CREDIT_CARD_TO_PROFILE_FAILED: new Error("Unable to add your card"),
  UPDATE_CREDIT_CARD_AND_SAVE_TO_PROFILE_FAILED: new Error("Unable to update your card"),
  DELETE_CREDIT_CARD_FROM_USER_PROFILE: new Error("Unable to delete your card"),
  DELETE_GIFT_CARD: new Error("Unable to delete your card"),
  RATE_USER_VISIT_FAILED: new Error("Unable to Rate your visit"),
  CREATE_ACCOUNT_FAILURE: new Error("Something went wrong.\nPlease try again!"),
  GET_FAVORITED_LOCATION: new Error("Unable to get your favorited Locations."),
  GET_RECENT_LOCATION: new Error("Unable to get your recent Locations."),
  GET_WEBAHEAD: new Error("We are unable to get your Waitlist Details, Please try again later."),
  UPDATE_PARTY_SIZE: new Error("Unable to Update Party Size, Please try again later"),
  DELETE_WEBAHEAD: new Error("Unable to Delete Waitlist"),
  CREATE_WAITLIST: new Error("Unable to join Waitlist for this restaurant, Please try again later."),
  CREATE_WAITLIST_TITLE: "CREATE-WAITLIST",
  GET_WAIT_TIME: new Error("Unable to get wait-time, please try again later."),
  APPLE_PAY_CANCELLED: new Error("Apple Pay Cancelled"),
  APPLE_PAY_ERRORED: new Error("Apple Pay Errored"),
  PAYPAL_CANCELLED: new Error("PayPal Cancelled"),
  PAYPAL_ERRORED: new Error("PayPal Errored"),
  GOOGLE_PAY_CANCELLED: new Error("Google Pay Cancelled"),
  GOOGLE_PAY_ERRORED: new Error("Google Pay Errored"),
  SOCIAL_LINK_FAILED: new Error("Unable to Link your Social Account.")
};
export var ERROR_STRINGS = {
  REMOVE_FAVORITE_LOCATION: "REMOVE FAVORITE LOCATION",
  SORRY_SOMETHING_WENT_WRONG: "Sorry, something went wrong"
};